var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightWebCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "event",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M21.334,24H2.666A2.547,2.547,0,0,1,0,21.6V4.8A2.547,2.547,0,0,1,2.666,2.4H4V0H6.667V2.4H17.333V0H20V2.4h1.333A2.547,2.547,0,0,1,24,4.8V21.6A2.547,2.547,0,0,1,21.334,24ZM2.666,8.4V21.6H21.334V8.4Zm16,10.8H12v-6h6.667v6Z",
    transform: "translate(0 0)",
    fill: "#36495a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightWebCalendarIcon);
export default __webpack_public_path__ + "static/media/Light_Web_Calendar_Icon.69a9e303628d08417266748ca994f8f9.svg";
export { ForwardRef as ReactComponent };